import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import { CrudeContext, useCrude } from '@3m5/crude-frontend/dist/crudeHooks'
import CssBaseline from '@mui/material/CssBaseline'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'

import { store, history } from '~store/init-store'
import { theme } from '~shared/muiTheme'
import { getCrudeConfiguration } from '~config/crudeConfig'

import SnackbarProvider from '~app/components/Toasts/SnackbarProvider'
import DisplayReduxToasts from '~app/components/Toasts/DisplayReduxToasts'
import '~shared/translations/i18next'
import 'fontsource-roboto'
import './fonts.css'
import DataProtection from '~app/screens/dataProtection/dataProtection'
import App from '~app/App'
import TranslationElement from '~shared/translations/translationElement'

function Bootstrap(): React.ReactElement {
  const crudeContext = useCrude({
    appPageProps: getCrudeConfiguration(),
    translationComponent: TranslationElement,
  })

  return (
    <Provider store={store}>
      <Router history={history}>
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst> {/** change injection order to not gives MUI precedence over your custom styles */}
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <CrudeContext.Provider value={crudeContext}>
                <CssBaseline />
                <SnackbarProvider>
                  <DisplayReduxToasts />
                  <Switch>
                    <Route extact path='/dataProtection' component={DataProtection} />
                    <Route component={App} />
                  </Switch>
                </SnackbarProvider>
              </CrudeContext.Provider>
            </LocalizationProvider>
          </StyledEngineProvider>
        </ThemeProvider>
      </Router>
    </Provider>
  )
}

ReactDOM.render(<Bootstrap />, window.document.getElementById('root'))
